export default __webpack_public_path__ + "static/media/0006.c5d6f085.png";